// extracted by mini-css-extract-plugin
module.exports = {"input":"Toggle_input__jadSo","toggle":"Toggle_toggle__pFeaP"};